<template>
    <div class="c-component">
        <button class="btn-info" @click.prevent="togglePopup">i</button>

        <div class="popup" v-if="popupVisible">
            <button class="btn-close" @click.prevent="closePopup"></button>

            <div v-html="this.popupText"></div>
        </div>
    </div>
</template>

<script>
export default {
    name : "ClientFormInfoButton",

    props: {
        popupText: {
            type: String,
            default: ""
        }
    },

    data() {
        return {
            popupVisible: false
        };
    },

    methods: {
        togglePopup() {
            this.popupVisible = !this.popupVisible;
        },

        closePopup() {
            this.popupVisible = false;
        }
    }
};
</script>

<style lang="scss" scoped>
    .c-component {
        position: relative;
    }

    .btn-info {
        position: absolute;
        width : 2rem;
        height : 2rem;
        background : $color-blue;
        border-radius: 50%;
        color : white;
        border : none;
        outline : none;
        font-size: 1em;
        font-weight: bold;
        margin-left: 0.5rem;
        margin-top: -0.3rem;
    }

    .btn-close {
        position: absolute;
        top : .5rem;
        right : .5rem;
        width : 2rem;
        height : 2rem;
        background-image : url("/img/icon-close-white.svg");
        border : solid .1rem white;
        border-radius: 50%;
        color : white;
        outline : none;
        background-color: transparent;
        background-size: 50%;
        background-position: center;
        background-repeat: no-repeat;
    }

    .popup {
        position : absolute;
        background : $color-blue;
        padding : 1.25rem;
        color : white;
        box-shadow: 0px 4px 6px 1px rgba(0, 0, 0, 15%);
        width: 25rem;
        text-align: left;
        font-size: .9em;
        font-size: .9em;
        bottom: 3.3rem;
        right: -3.5rem;
        z-index: 80;

    }

    :deep(.popup) {
        h6 {
            font-size : 1.1em;
            padding-top : 0;
            margin-top : 0;
            padding-bottom : 0;
            margin-bottom : .5rem;
            text-decoration: underline;
        }

        p {
            line-height:1.3em;

            &:last-child {
                margin-bottom : 0;
            }
        }
    }
</style>